import React from "react"; // Required for JSX even if not explicitly used
import { Button } from '@/components/ui/button';
import TopHeader  from "../components/TopHeader"; // Import Settings icon
import BottomNav  from "../components/BottomNav"; // Import Settings icon
import { Camera, ImageIcon, VideoIcon } from 'lucide-react';

export default function ScanPage() {

  return (
    <div className=" flex-col h-screen bg-gray-100">
      {/* Header */}
      <TopHeader/>

      {/* Main content area */}
      <main className="flex flex-col items-center justify-center space-y-8 bg-gray-200">
        {/* Placeholder for scan preview */}
        <div className="translate-y-3 w-64 h-64 bg-black rounded-lg flex items-center justify-center text-white text-lg">
          Scan Preview
        </div>

        {/* Bottom action buttons */}
        <div className="translate-y-3 flex flex-row justify-around w-full">
          <Button variant="outline" className="flex flex-col items-center space-y-1">
            <ImageIcon size={40} />
            <span>Gallery</span>
          </Button>
          <Button variant="default" className="flex flex-col items-center space-y-1">
            <Camera size={40} />
            <span>Photo</span>
          </Button>
          <Button variant="destructive" className="flex flex-col items-center space-y-1">
            <VideoIcon size={32} />
            <span>Video</span>
          </Button>
        </div>
        
      </main>
       {/* Bottom Navigation */}
       <footer className="fixed bottom-0 left-0 right-0 bg-white border-t p-2 flex justify-around items-center text-gray-600 shadow-lg">
           <BottomNav/>
       </footer>
    </div>
  );
}
